import * as React from 'react';

import {Avatar} from 'shells/avatar/avatar';
import type {TwoLineOptionWithIcon} from 'shells/select-two-line-icon/select-two-line-icon';

import type {Option} from '../../../core/select/graphql-select-inline';

export const mapOptionToValue = (options: TwoLineOptionWithIcon<any>[]): Option[] => {
    if (options.length === 0) {
        return [];
    }

    return options.map((option) => {
        return {
            id: option.value,
            name: option.label,
            // Flow doesn't like that we are accessing props on a React Node,
            // but it is guaranteed to exist here
            // @ts-expect-error
            avatarUrl: option.iconNode.props.avatarUrl,
            // @ts-expect-error
            initials: option.iconNode.props.initials,
        };
    });
};

export const mapValueToOption = (values: Option[]): TwoLineOptionWithIcon<any>[] => {
    if (values.length === 0) {
        return [];
    }

    return values.map((value) => {
        return {
            value: value.id,
            label: value.name,
            iconNode: (
                <Avatar
                    size={20}
                    type='leads'
                    avatarUrl={value.avatarUrl}
                    initials={value.initials}
                />
            ),
            href: value.metaData ? value.metaData.href : '',
        };
    });
};

export const getActivityLink = (activityId: string) => {
    const pathName = window.location.pathname;
    const newUrl = `${pathName}#/${activityId}`;

    return newUrl;
};
